module.exports = {
  displayName: 'PROOF OF DELIVERY',
  description: 'Manages the flow after delivery',
  sortOrder: 7,
  name: 'pod',
  documentKey: 'pod',
  sections: {
  },
};
